import type { FC } from "react";
import { Form, type FormProps } from "redux-form";

import style from "./styles/Form.module.scss";

export interface SelFormProps extends FormProps<any, any> {
  children: React.ReactNode;
}

const SelForm: FC<SelFormProps> = (props) => {
  const { children, ...formProps } = props;
  return (
    <Form {...formProps} className={style.form}>
      {props.children}
    </Form>
  );
};

export { SelForm };
